// Запись: офлайн-очередь (pendingOps) отправляется в Cloudflare Worker.
// Объявление попадёт к другим пользователям после модерации владельцем
// (npm run sync) и публикации следующего снапшота.

import type { SubmitBody } from '@barter/shared';
import { API_BASE } from './api-base';
import { authHeaders } from './auth';

export class SubmitError extends Error {
  status: number;
  details?: string[];

  constructor(status: number, message: string, details?: string[]) {
    super(message);
    this.status = status;
    this.details = details;
  }
}

async function submit(body: SubmitBody, timeoutMs = 30_000): Promise<{ ok: boolean }> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(`${API_BASE}/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    if (!res.ok) {
      const err = (await res.json().catch(() => ({}))) as { error?: string; details?: string[] };
      throw new SubmitError(res.status, err.error || `HTTP ${res.status}`, err.details);
    }
    return (await res.json()) as { ok: boolean };
  } finally {
    clearTimeout(timer);
  }
}

/** Отправка одной операции из очереди. Повторный вызов с тем же uuid — не дубликат. */
export function submitOp(body: SubmitBody): Promise<{ ok: boolean }> {
  return submit(body);
}

/** Счётчик просмотров: fire-and-forget, без очереди. */
export function submitView(adId: string): void {
  submit({ uuid: `view-${adId}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, kind: 'view', payload: { adId } }).catch(
    () => {},
  );
}
